import { render } from "./viewquotation.vue?vue&type=template&id=4eb268fe&scoped=true"
import script from "./viewquotation.vue?vue&type=script&lang=js"
export * from "./viewquotation.vue?vue&type=script&lang=js"

import "./viewquotation.vue?vue&type=style&index=0&id=4eb268fe&scoped=true&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb268fe"]])

export default __exports__